import React, { Component } from 'react';
import { RegionType } from './RegionType.enum';
import { LayoutContext } from './LayoutContext';

export class BasePanel extends Component {
	calculateTop = region => {
		const { getRegionHeight } = this.context;
		const northLayoutHeight = getRegionHeight(RegionType.North);

		switch (region) {
			case RegionType.North:
				return 0;

			case RegionType.West:
			case RegionType.East:
			case RegionType.Center:
				return `${northLayoutHeight}px`;

			default:
				return null;
		}
	};

	calculateLeft = region => {
		const { getRegionWidth } = this.context;
		const westLayoutWidth = getRegionWidth(RegionType.West);

		switch (region) {
			case RegionType.North:
			case RegionType.West:
				return 0;

			case RegionType.Center:
				return `${westLayoutWidth}px`;

			default:
				return null;
		}
	};

	calculateRight = region => {
		switch (region) {
			case RegionType.East:
				return 0;

			default: {
				return null;
			}
		}
	};

	calculateWidth = region => {
		const { getRegionWidth } = this.context;
		const westLayoutWidth = getRegionWidth(RegionType.West);
		const eastLayoutWidth = getRegionWidth(RegionType.East);

		switch (region) {
			case RegionType.North:
				return '100%';

			case RegionType.West:
				return `${westLayoutWidth}px`;

			case RegionType.East:
				return `${eastLayoutWidth}px`;

			case RegionType.Center:
				return `calc(100% - ${westLayoutWidth}px - ${eastLayoutWidth}px)`;

			default:
				return null;
		}
	};

	calculateHeight = region => {
		const { getRegionHeight } = this.context;
		const northLayoutHeight = getRegionHeight(RegionType.North);

		switch (region) {
			case RegionType.North:
				return `${northLayoutHeight}px`;

			case RegionType.West:
			case RegionType.East:
			case RegionType.Center:
				return `calc(100% - ${northLayoutHeight}px)`;

			default:
				return null;
		}
	};

	render() {
		const { className, region, children } = this.props;
		return (
			<div
				className={className}
				style={{
					position: 'absolute',
					top: this.calculateTop(region),
					left: this.calculateLeft(region),
					right: this.calculateRight(region),
					width: this.calculateWidth(region),
					height: this.calculateHeight(region),
				}}
			>
				{children}
			</div>
		);
	}
}

BasePanel.contextType = LayoutContext;
